// extracted by mini-css-extract-plugin
module.exports = {"root":"Qualiphy_root__3fx_b","boxTitle":"Qualiphy_boxTitle__3lcOz","box":"Qualiphy_box__2SgTO","toggleWrap":"Qualiphy_toggleWrap__37r9v"};